import React from 'react';
import { withStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ButtonBase from '../Buttons/ButtonBase';

const lawyerVerificationEmail = '/img/recover-password/persona-1.svg';

const styles = () => ({
  img: {
    position: 'absolute',
    left: '50%',
    top: 8,
    transform: 'translate(-50%)'
  },
  title: { backgroundColor: '#c1c1c1', height: 100 },
  content: {
    marginTop: 60,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  actions: {
    padding: 32,
    textAlign: 'center',
    margin: '0 auto'
  },
  noticeText: {
    fontWeight: 'bold',
    width: 290,
    margin: '0 auto',
    lineHeight: 1.2
  },
  contentText: {
    width: 300,
    fontSize: 12,
    lineHeight: 1.2
  }
});

function EmailModal(props) {
  const { classes, noticeText, email, handleClick } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [open, setOpen] = React.useState(true);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      maxWidth="xs"
      disableEscapeKeyDown
      open={open}
      onClose={handleClick}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle id="dialog-title" className={classes.title}>
        <img
          src={lawyerVerificationEmail}
          alt="Contacta Abogado Verificación de Correo Electrónico"
          className={classes.img}
        />
      </DialogTitle>
      <DialogContent className={classes.content}>
        <div>
          <Typography
            className={classes.noticeText}
            variant="h6"
            color="primary"
            align="center"
            paragraph
          >
            {noticeText}
          </Typography>
          <DialogContentText
            id="dialog-description"
            align="center"
            className={classes.contentText}
            paragraph
          >
            <br />
            Sigue las instrucciones que ahí te indicamos para continuar con tu
            proceso de registro.
            <br />
            <br />
            <span style={{ fontSize: 18 }}>{email}</span>
            <br />
            <br />
            Tienes un máximo de 24 horas para completar el Registro. Si no lo
            haces dentro de ese periodo, tendrás que iniciar nuevamente el
            proceso.
          </DialogContentText>
        </div>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <ButtonBase
          type="button"
          variant="primary"
          autoFocus
          onClick={handleClick}
        >
          Entendido
        </ButtonBase>
      </DialogActions>
    </Dialog>
  );
}

export default withStyles(styles)(EmailModal);
